import { queryBuilder } from '@inpart-io/devtools-iap';
import { RECEIVE_DATA_OBJECTS, RETRIEVE_BY_QUERY, STORE_DATA_OBJECTS } from '@inpart-io/devtools-vue';
import { type IPrivateCompany, type IPrivateContactCompany } from '@inpart-io/padme-iap';
import { type ActionTree } from 'vuex';

import { getDobjId } from '@/services/data-object-helper';
import { PRIVATE_COMPANY_MODULE } from '@/store/private-company-module';

import { GET_FROM_CONTACT } from './getters';
import { RECEIVE_BY_CONTACT } from './mutations';

export const ADD_TO_CONTACT = 'addToContact';
export const RETRIEVE_BY_CONTACT = 'retrieveByContact';
export const RETRIEVE_BY_CONTACT_LIST = 'retrieveByContactList';

export const actions: ActionTree<IPrivateContactCompany, unknown> = {
    [ADD_TO_CONTACT](context, { contactId, contactCompanyId }: { contactId: number; contactCompanyId: number }): number[] {
        const idList: number[] = (context.getters[GET_FROM_CONTACT](contactId) ?? []).map((contactCompany: IPrivateContactCompany) => {
            return contactCompany.dobjId;
        });
        idList.unshift(contactCompanyId);
        context.commit(RECEIVE_BY_CONTACT, { contactId, idList });
        return idList;
    },
    async [RETRIEVE_BY_CONTACT](context, { contactId, properties }: { contactId: number; properties?: string }): Promise<number[]> {
        const idList = await context.dispatch(RETRIEVE_BY_QUERY, {
            query: queryBuilder.build(queryBuilder.op.and(queryBuilder.cmp.refersTo('contact', contactId)), undefined, undefined, [
                { direction: 'ASC', attribute: 'position' }
            ]),
            properties
        });
        return idList;
    },
    async [RETRIEVE_BY_CONTACT_LIST](context, { contactIdList, properties }: { contactIdList: number[]; properties?: string }): Promise<number[]> {
        const idList = await context.dispatch(RETRIEVE_BY_QUERY, {
            query: queryBuilder.build(queryBuilder.op.and(queryBuilder.cmp.isIn('contact', contactIdList)), undefined, undefined, [
                { direction: 'ASC', attribute: 'position' }
            ]),
            properties
        });
        return idList;
    },
    [STORE_DATA_OBJECTS](context, { dataObjectList }: { dataObjectList: IPrivateContactCompany[] }) {
        const companies: IPrivateCompany[] = [];
        const contactCompanies: IPrivateContactCompany[] = [];
        const byContact = new Map<number, number[]>();
        dataObjectList.forEach((contactCompany) => {
            let _contactCompany = Object.assign({}, contactCompany);

            if (contactCompany.company !== null && contactCompany.company !== undefined && isNaN(contactCompany.company)) {
                const company = contactCompany.company as unknown as IPrivateCompany;
                companies.push(company);
                _contactCompany = Object.assign({}, contactCompany, { company: company.dobjId });
            }

            contactCompanies.push(_contactCompany);

            if (contactCompany.contact !== null && contactCompany.contact !== undefined) {
                const list = byContact.get(getDobjId(contactCompany.contact)) ?? [];
                list.push(contactCompany.dobjId);
                byContact.set(getDobjId(contactCompany.contact), list);
            }
        });

        if (contactCompanies.length > 0) {
            context.commit(RECEIVE_DATA_OBJECTS, { dataObjectList: contactCompanies });
        }
        if (companies.length > 0) {
            void context.dispatch(`${PRIVATE_COMPANY_MODULE}/${STORE_DATA_OBJECTS}`, { dataObjectList: companies }, { root: true });
        }
        byContact.forEach((idList, contactId) => {
            context.commit(RECEIVE_BY_CONTACT, { contactId, idList });
        });
    }
};
